import '../styles.scss';
import React from 'react';
import Chart from 'react-apexcharts';
import lineBreaker from 'helpers/LineBreaker';
import SemDados from '../SemDados';

const marcasFixasArray = ['BASSI', 'MONTANA STEAKHOUSE', 'MONTANA'];

const MarcaSolicitacoes = (props) => {
  const { data } = props;

  const titulo = 'SOLICITAÇÕES POR MARCA';

  if (!data || Object.keys(data).length === 0)
    return <SemDados titulo={titulo} />;

  const marcas = Object.keys(data);
  const dataMarcasFixas = {};
  const dataMarcasOutros = {};

  // filtrando marcas fixas e outras
  marcas.forEach((marca) => {
    if (marcasFixasArray.includes(marca.toUpperCase())) {
      dataMarcasFixas[marca] = data[marca];
    } else {
      dataMarcasOutros[marca] = data[marca];
    }
  });

  // adicionando OUTROS
  dataMarcasFixas.OUTROS = {
    quantidade: 0,
    percentual: 0,
  };

  // somando quantidade e percentual de OUTROS
  Object.keys(dataMarcasOutros).forEach((marca) => {
    dataMarcasFixas.OUTROS.quantidade += dataMarcasOutros[marca].quantidade;
    dataMarcasFixas.OUTROS.percentual += dataMarcasOutros[marca].percentual;
  });

  const marcasFixas = Object.keys(dataMarcasFixas);
  // const marcasOutros = Object.keys(dataMarcasOutros);

  const series = [
    { data: marcasFixas.map((marca) => dataMarcasFixas[marca].quantidade) },
  ];

  const options = {
    legend: {
      show: false,
    },
    colors: ['#ed1d24', '#fa6e0a', '#011689', '#d3d3d3'],
    plotOptions: {
      bar: {
        distributed: true,
        horizontal: false,
        dataLabels: {
          position: 'top',
        },
        colors: {},
      },
    },
    xaxis: {
      show: true,
      labels: {
        show: true,
        hideOverlappingLabels: false,
        rotate: 0,
        style: {
          fontWeight: 600,
          fontSize: '12px',
        },
        formatter: (value) => {
          const lines = lineBreaker(value.toUpperCase(), 7);
          return lines;
        },
      },
      categories: marcasFixas,
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
    },
    yaxis: {
      show: false,
    },
    grid: {
      show: false,
    },
    chart: {
      id: 'mar-solicitacoes',
      parentHeightOffset: 8,
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      hideOverflowingLabels: false,
      textAnchor: 'middle',
      offsetX: 0,
      offsetY: -19,
      formatter: (value, { dataPointIndex }) => {
        return `${value}(${dataMarcasFixas[
          marcasFixas[dataPointIndex]
        ].percentual.toFixed(2)}%)`;
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#373d3f'],
      },
    },
    tooltip: {
      shared: false,
      followCursor: true,
      intersect: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      // eslint-disable-next-line
      custom: ({ series, seriesIndex, dataPointIndex }) => {
        return marcasFixasArray.includes(
          marcasFixas[dataPointIndex].toUpperCase()
        )
          ? `<div class="arrow_box">
            <span>
              Marca: <span id="data">${marcasFixas[
                dataPointIndex
              ].toUpperCase()}</span>
            </span>
            <span>
              Total de Solicitações: <span id="data">${
                series[seriesIndex][dataPointIndex]
              }</span>
            </span>
            <span>
              %: <span id="data">${dataMarcasFixas?.[
                marcasFixas[dataPointIndex]
              ].percentual.toFixed(2)}</span>
            </span>
          </div>
          `
          : `<div class="arrow_box">
              <span>Outras Marcas:</span>
              ${Object.keys(dataMarcasOutros)
                .map((marca) => {
                  return `<span>${marca.toUpperCase()}: <span id="data">${
                    dataMarcasOutros?.[marca]?.quantidade
                  } (${dataMarcasOutros?.[marca]?.percentual.toFixed(
                    2
                  )}%)</span></span>`;
                })
                .join('')}
            </div>`;
      },
    },
  };
  return (
    <div className="grafico">
      <div className="grafico-titulo">
        <span>{titulo}</span>
      </div>
      <Chart options={options} series={series} type="bar" height="300" />
    </div>
  );
};

export default MarcaSolicitacoes;
